module.exports = __WEBPACK_EXTERNAL_MODULE_powerbi_client__;